module.exports = __webpack_public_path__ + "static/media/LogicWheel1_1_1.2d109bed.png";